<cb-dialog dialogHeading="Submit to Council">
    <form class="flex-col flex"
          #submitToCouncilForm="ngForm">
        <cb-input type="text"
                  label="Consent Number"
                  name="consentNumber"
                  [(ngModel)]="mappedItem.consentNumber"
                  [softRequired]="true"
                  autocomplete="off"></cb-input>
    </form>
    <div actions>
        <button mat-raised-button
                color="primary"
                [disabled]="submitToCouncilForm.invalid"
                (cbClick)="save()"
                [clickLimit]="1">Submit
      </button>
        <button mat-raised-button
                (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
